module.exports = __webpack_public_path__ + "img/20230719125339670iyv.60eb8fcd.jpg";